import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Handshake, Building2, Factory, ShoppingBag, Truck, Hotel, Phone, Mail, ArrowRight, CheckCircle2, Users, Target, Award } from 'lucide-react';

const ReferanslarimizPage = () => {
  const sectors = [
    { icon: Factory, name: 'Üretim & Sanayi', count: '50+' },
    { icon: Building2, name: 'Kurumsal Şirketler', count: '30+' },
    { icon: ShoppingBag, name: 'Perakende', count: '25+' },
    { icon: Truck, name: 'Lojistik', count: '20+' },
    { icon: Hotel, name: 'Hizmet Sektörü', count: '40+' },
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="pt-44 pb-16 bg-gradient-to-br from-slate-50 via-blue-50/30 to-white">
        <div className="eta-container">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-[#005CB2] font-semibold tracking-wider mb-3">REFERANSLARIMIZ</p>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Güvenilir İş Ortaklıkları
            </h1>
            <p className="text-lg text-slate-600">
              10+ yıllık deneyimimizle Türkiye'nin önde gelen firmalarıyla uzun soluklu 
              iş birlikleri yürütüyoruz. Birçok sektörde öncü markalarla çalışmaktayız.
            </p>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-20 bg-white">
        <div className="eta-container">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Uzmanlık Alanlarımız
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Eta Global Group olarak, insan kaynakları sektöründe edindiğimiz derin bilgi birikimi ve 
                deneyimle müşterilerimize değer katıyoruz. Her sektörün kendine özgü dinamiklerini anlıyor, 
                ihtiyaçlara özel çözümler üretiyoruz.
              </p>
              <p className="text-slate-600 mb-8 leading-relaxed">
                Personel tedarikinden eğitim danışmanlığına, kurumsal baskı çözümlerinden araç kiralama 
                hizmetlerine kadar geniş bir yelpazede profesyonel destek sunuyoruz. Müşterilerimizin 
                operasyonel verimliliğini artırırken, iş süreçlerini optimize etmelerine yardımcı oluyoruz.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[#005CB2] flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-semibold text-slate-900">Sektörel Deneyim</h4>
                    <p className="text-sm text-slate-600">Her sektörün ihtiyaçlarına uygun özelleştirilmiş çözümler</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[#005CB2] flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-semibold text-slate-900">Profesyonel Kadro</h4>
                    <p className="text-sm text-slate-600">Alanında uzman ve deneyimli ekip üyeleri</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[#005CB2] flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-semibold text-slate-900">Sürdürülebilir İş Birlikleri</h4>
                    <p className="text-sm text-slate-600">Uzun vadeli ortaklıklar ve güvene dayalı ilişkiler</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-[#005CB2]/5 to-[#005CB2]/10 rounded-2xl p-6 text-center">
                <Users className="w-12 h-12 text-[#005CB2] mx-auto mb-4" />
                <p className="text-3xl font-bold text-slate-900 mb-1">5000+</p>
                <p className="text-sm text-slate-600">İstihdam Edilen Personel</p>
              </div>
              <div className="bg-gradient-to-br from-[#005CB2]/5 to-[#005CB2]/10 rounded-2xl p-6 text-center">
                <Building2 className="w-12 h-12 text-[#005CB2] mx-auto mb-4" />
                <p className="text-3xl font-bold text-slate-900 mb-1">165+</p>
                <p className="text-sm text-slate-600">Aktif Müşteri</p>
              </div>
              <div className="bg-gradient-to-br from-[#005CB2]/5 to-[#005CB2]/10 rounded-2xl p-6 text-center">
                <Target className="w-12 h-12 text-[#005CB2] mx-auto mb-4" />
                <p className="text-3xl font-bold text-slate-900 mb-1">%98</p>
                <p className="text-sm text-slate-600">Müşteri Memnuniyeti</p>
              </div>
              <div className="bg-gradient-to-br from-[#005CB2]/5 to-[#005CB2]/10 rounded-2xl p-6 text-center">
                <Award className="w-12 h-12 text-[#005CB2] mx-auto mb-4" />
                <p className="text-3xl font-bold text-slate-900 mb-1">10+</p>
                <p className="text-sm text-slate-600">Yıllık Tecrübe</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sectors Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="eta-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Hizmet Verdiğimiz Sektörler
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Farklı sektörlerdeki deneyimimizle her alanda uzman çözümler sunuyoruz
            </p>
          </div>
          
          <div className="grid md:grid-cols-5 gap-6">
            {sectors.map((sector, index) => (
              <div 
                key={index}
                className="group bg-white rounded-2xl p-6 border border-slate-100 hover:shadow-xl hover:border-[#005CB2]/20 transition-all duration-300 text-center"
              >
                <div className="w-16 h-16 bg-[#005CB2]/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-[#005CB2] transition-colors">
                  <sector.icon className="w-8 h-8 text-[#005CB2] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-bold text-slate-900 mb-1">{sector.name}</h3>
                <p className="text-2xl font-bold text-[#005CB2]">{sector.count}</p>
                <p className="text-sm text-slate-500">Referans</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="eta-container">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12">
            <div className="flex flex-col items-center text-center">
              <Handshake className="w-16 h-16 text-[#005CB2] mb-6" />
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Referanslarımız Hakkında Bilgi Alın
              </h2>
              <p className="text-slate-300 mb-8 max-w-xl">
                Sektörünüze özel referanslarımız ve başarı hikayelerimiz hakkında 
                detaylı bilgi almak için bizimle iletişime geçin.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/iletisim">
                  <Button className="bg-[#005CB2] hover:bg-[#004a91] text-white gap-2">
                    <Mail className="w-4 h-4" />
                    İletişime Geçin
                  </Button>
                </Link>
                <a href="tel:+905334143024">
                  <Button variant="outline" className="border-slate-500 text-white hover:bg-white/10 gap-2">
                    <Phone className="w-4 h-4" />
                    0533 414 30 24
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ReferanslarimizPage;
